import { useRouteLoaderData } from 'react-router';

import { useI18n } from '#/i18n/hooks/useI18n';

export function useSearchJobsRouteLoaderData() {
  const { locale } = useI18n();
  const loaderData = useRouteLoaderData<{
    synonym: { familyId: string; jobSynonym: { name: string } };
    facetCounts: number;
  } | null>(`search-jobs-${locale}`)!;

  const { synonym, facetCounts } = loaderData ?? {};

  const {
    familyId,
    jobSynonym: { name },
  } = synonym ?? {
    familyId: null,
    jobSynonym: { name: null },
  };

  return { jobSynonymName: name, jobFamilyId: familyId, facetCounts };
}
